import * as React from 'react';
import { useState } from 'react';

import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { Button, ButtonContainer, Modal, ModalHeader, Typography } from '@emburse/ui-core';

import { Select } from '@ReactComponents/Select';

import { IAppStateContainer } from '@Reducers/index';

import { LinkedAccountsApiService } from '@ClientApi/linkedAccounts';

interface IAddUserConnectedSubaccountModalOwnProps {
  linkedAccountId: string;
  closeModal: () => void;
  onCardAdded: () => void;
}

export const AddUserConnectedSubaccountModal: React.FC<IAddUserConnectedSubaccountModalProps> = ({
  linkedAccountId,
  closeModal,
  users,
  onCardAdded
}) => {
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const usersOptions = users.map((user) => {
    return {
      value: user.id,
      label: user.name || user.email
    };
  });

  async function addCards() {
    try {
      setLoading(true);
      await LinkedAccountsApiService.addCards(linkedAccountId, { user_ids: selectedIds });
      toast.success('Cards added');
      onCardAdded();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
      closeModal();
    }
  }

  function modalHeader() {
    return <ModalHeader title={'Add Subaccount Cards'} onCloseClicked={() => closeModal()} />;
  }

  return (
    <Modal open={true} onClose={() => closeModal()} modalHeader={modalHeader()} isLoading={loading}>
      <Typography gutterBottom variant={'h6'}>
        Select the team members who have corporate cards
      </Typography>
      <Select
        isMulti
        options={usersOptions}
        value={usersOptions.filter((option: { label: string; value: string }) => selectedIds.indexOf(option.value) > -1)}
        onChange={(values: { label: string; value: string }[]) => setSelectedIds(values.map((option) => option.value))}
      />
      <Typography gutterBottom>
        They will be prompted to connect their cards to {window.whitelabelConfiguration.tags.brandName}. You can always add more team
        members later.
      </Typography>
      <ButtonContainer alignButtons={'right'} style={{ marginTop: 30 }}>
        <Button primary variant="outlined" onClick={closeModal}>
          Cancel
        </Button>
        <Button primary onClick={addCards} disabled={selectedIds.length === 0}>
          Add Cards
        </Button>
      </ButtonContainer>
    </Modal>
  );
};

const mapStateToProps = (state: IAppStateContainer, ownProps: IAddUserConnectedSubaccountModalOwnProps) => ({
  ...ownProps,
  users: state.users.usersActiveOrInvited
});

export type IAddUserConnectedSubaccountModalProps = ReturnType<typeof mapStateToProps>;
export const AddUserConnectedSubaccountModalConnected = connect(mapStateToProps, {})(AddUserConnectedSubaccountModal);
